import { ClassTimeSchedule } from "./class-time-schedule";
import { Notifications } from "../notifications";
import { Price } from "./price";
import { Enrollment } from "./enrollment";
import { WeekDays } from "./week-days";
import { HybridCheck } from "./hybrid-check";
import { TotalMonthlyPayments } from "./total-monthly-payments";
import { OtherPrices } from "./other-prices";
export class SaveCourse {
    constructor(form) {
        this.inputsValidators = [];
        this.addValidator(ClassTimeSchedule.create(form));
        this.addValidator(WeekDays.create(form));
        this.addValidator(Price.create(form));
        this.addValidator(Enrollment.create(form));
        HybridCheck.create(form);
        TotalMonthlyPayments.create(form);
        OtherPrices.create(form);
        form.addEventListener("submit", (e) => {
            const errors = [];
            for (const inputsValidator of this.inputsValidators) {
                const error = inputsValidator.validate();
                if (error !== null) {
                    errors.push(error);
                }
            }
            if (errors.length > 0) {
                e.preventDefault();
                Notifications.error(errors.join("\n\n"));
            }
        });
    }
    addValidator(validator) {
        if (validator === null) {
            return;
        }
        this.inputsValidators.push(validator);
    }
    static initialize() {
        const form = document.querySelector("form.js-save-course");
        if (form !== null) {
            new SaveCourse(form);
        }
    }
}
